const FormSection = () => {
  return (
    <section id="registration" className="relative pt-16 pb-16">
      <div className="container mx-auto px-4">
        <div className="bg-white w-full md:w-8/12 lg:w-6/12 mx-auto shadow-lg rounded-xl">
          <div className="pt-2 md:px-4 lg:px-6 py-8 w-full">
            <iframe
              title="Registration"
              src="https://forms.zohopublic.com/utiva/form/JOINTHEUTIVANETWORKACCESSTHE40PAGEDOCUMENTONHOWTOL/formperma/_zm7HBLgSVex_P2UZQB2UCfrihWcGjM-GiboPAv6AMA"
              width="100%"
              height="2100"
              frameborder="0"
              style={{ border: 0 }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormSection;
